// extracted by mini-css-extract-plugin
export default {"navigationContainer":"Nav_navigationContainer__ZhOoV","navLink":"Nav_navLink__-T2QO","navImg":"Nav_navImg__FMIgT"};